import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=4fc8aefa&scoped=true"
import script from "./Overall.vue?vue&type=script&lang=js"
export * from "./Overall.vue?vue&type=script&lang=js"
import style0 from "./Overall.vue?vue&type=style&index=0&id=4fc8aefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8aefa",
  null
  
)

export default component.exports